import script from "./OpenVip.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenVip.vue?vue&type=script&setup=true&lang=js"

import "./OpenVip.vue?vue&type=style&index=0&id=3794d94d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3794d94d"]])

export default __exports__